export default "__VITE_ASSET__Dsqpja_m__"